/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createTaskItemFromDiscriminatorValue, serializeChangeTaskStatusRequest, serializeTaskItem, type ChangeTaskStatusRequest, type ErrorResponse, type InternalErrorResponse, type TaskItem } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/tasks/{taskItemId}/status
 */
export interface StatusRequestBuilder extends BaseRequestBuilder<StatusRequestBuilder> {
    /**
     * Moves a task through its lifecycle: an open task can be started, completed or cancelled; a task in progress can be completed, cancelled or reopened; a completed or cancelled task can only be reopened. Any other move, including to the status the task already has, is a 400 that says which moves are allowed, and the task is left as it was. Completing records when, and whose name from the body, so the name is required then; reopening clears that record, so a reopened task reads as never completed until it is completed again. The same visibility rule as reading applies: a task the caller cannot see reads as 404.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<TaskItem>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     patch(body: ChangeTaskStatusRequest, requestConfiguration?: RequestConfiguration<StatusRequestBuilderPatchQueryParameters> | undefined) : Promise<TaskItem | undefined>;
    /**
     * Moves a task through its lifecycle: an open task can be started, completed or cancelled; a task in progress can be completed, cancelled or reopened; a completed or cancelled task can only be reopened. Any other move, including to the status the task already has, is a 400 that says which moves are allowed, and the task is left as it was. Completing records when, and whose name from the body, so the name is required then; reopening clears that record, so a reopened task reads as never completed until it is completed again. The same visibility rule as reading applies: a task the caller cannot see reads as 404.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPatchRequestInformation(body: ChangeTaskStatusRequest, requestConfiguration?: RequestConfiguration<StatusRequestBuilderPatchQueryParameters> | undefined) : RequestInformation;
}
/**
 * Moves a task through its lifecycle: an open task can be started, completed or cancelled; a task in progress can be completed, cancelled or reopened; a completed or cancelled task can only be reopened. Any other move, including to the status the task already has, is a 400 that says which moves are allowed, and the task is left as it was. Completing records when, and whose name from the body, so the name is required then; reopening clears that record, so a reopened task reads as never completed until it is completed again. The same visibility rule as reading applies: a task the caller cannot see reads as 404.
 */
export interface StatusRequestBuilderPatchQueryParameters {
    userId?: string;
}
/**
 * Uri template for the request builder.
 */
export const StatusRequestBuilderUriTemplate = "{+baseurl}/api/tasks/{taskItemId}/status{?userId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const StatusRequestBuilderRequestsMetadata: RequestsMetadata = {
    patch: {
        uriTemplate: StatusRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createTaskItemFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeChangeTaskStatusRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
